import React from 'react';
import { View } from 'react-native-web';
import {
  enter_a_custom_reason,
  getSubCategoryId, Main_screen, select_a_photo_str, select_a_reason,
  Step_1_main,
  Step_2_select,
  Step_3_enter, Thanks_for_dinner_str, Upload_photo_from_device,
} from '../../../utils/DictionaryManagementUtils';
import ReferenceEnterCustomReasonFP from '../FullPagesComponents/Services/Reference/ReferenceEnterCustomReasonFP';
import ReferenceSelectReasonFP from '../FullPagesComponents/Services/Reference/ReferenceSelectReasonFP';
import ReferenceMainScreenFP from '../FullPagesComponents/Services/Reference/ReferenceMainScreenFP';
import SimulatorsViewerArrangement from '../FullPagesComponents/SimulatorsViewerArrangement';
import ReferenceUploadPhotoFP from '../FullPagesComponents/Services/Reference/ReferenceUploadPhotoFP';

const ReferenceDF = ({
  globJSON,
  selectedScreen,
  simPlatform,
  slideshowRefs = null,
}) => {
  const myScreen = globJSON.screens[selectedScreen];
  const subCategoryId = getSubCategoryId(myScreen);
  const { reference } = globJSON.configurations.services[subCategoryId];
  const notSkipped = reference.step_enabled;
  const selectOptions = reference.select_reason_from_options;
  const customer_add_photo = reference.customers_add_photo_enabled;
  const showRightPhone = slideshowRefs === null || notSkipped;

  //= ====================================================================
  if (!showRightPhone) {
    return null;
  }
  return (
    <View>
      {customer_add_photo
        ? (
          <SimulatorsViewerArrangement>
            <ReferenceMainScreenFP
              globJSON={globJSON}
              simPlatform={simPlatform}
              selectOptions={selectOptions}
              subCategoryId={subCategoryId}
              TopTitle={selectOptions ? Main_screen : Step_1_main}
              WithGrayBackground={!notSkipped}
              slideshowRefs={slideshowRefs}
              withAddPhoto
            />
            {selectOptions ? (
              <ReferenceSelectReasonFP
                globJSON={globJSON}
                simPlatform={simPlatform}
                subCategoryId={subCategoryId}
                TopTitle={select_a_reason}
                WithGrayBackground={!notSkipped}
                slideshowRefs={slideshowRefs}
              />
            ) : (
              <ReferenceMainScreenFP
                globJSON={globJSON}
                simPlatform={simPlatform}
                selectOptions={selectOptions}
                subCategoryId={subCategoryId}
                TopTitle={select_a_photo_str}
                WithGrayBackground={!notSkipped}
                inputText={Thanks_for_dinner_str}
                slideshowRefs={slideshowRefs}
                withAddPhoto
                showOneBigImage
                withSubCategory
              />
            )}
            {selectOptions ? ((selectOptions && reference.custom_reason) ? (
              <ReferenceEnterCustomReasonFP
                globJSON={globJSON}
                simPlatform={simPlatform}
                subCategoryId={subCategoryId}
                TopTitle={enter_a_custom_reason}
                WithGrayBackground={!notSkipped}
                inputText={Thanks_for_dinner_str}
                withSubCategory
                headlineText={reference.add_a_reference}
                slideshowRefs={slideshowRefs}
                withOutKeyboard
                withPrimaryColor
              />
            ) : (
              <ReferenceMainScreenFP
                globJSON={globJSON}
                simPlatform={simPlatform}
                selectOptions={selectOptions}
                subCategoryId={subCategoryId}
                TopTitle={select_a_photo_str}
                WithGrayBackground={!notSkipped}
                slideshowRefs={slideshowRefs}
                withAddPhoto
                showOneBigImage
              />
            )) : (
              <ReferenceUploadPhotoFP
                globJSON={globJSON}
                simPlatform={simPlatform}
                selectOptions={selectOptions}
                subCategoryId={subCategoryId}
                TopTitle={Upload_photo_from_device}
                WithGrayBackground={!notSkipped}
                slideshowRefs={slideshowRefs}
                withAddPhoto
                showOneBigImage
              />
            )}
            {selectOptions && ((selectOptions && reference.custom_reason) ? (
              <ReferenceMainScreenFP
                globJSON={globJSON}
                simPlatform={simPlatform}
                selectOptions={selectOptions}
                subCategoryId={subCategoryId}
                TopTitle={select_a_photo_str}
                WithGrayBackground={!notSkipped}
                slideshowRefs={slideshowRefs}
                withAddPhoto
                showOneBigImage
              />
            ) : (
              <ReferenceUploadPhotoFP
                globJSON={globJSON}
                simPlatform={simPlatform}
                selectOptions={selectOptions}
                subCategoryId={subCategoryId}
                TopTitle={Upload_photo_from_device}
                WithGrayBackground={!notSkipped}
                slideshowRefs={slideshowRefs}
                withAddPhoto
                showOneBigImage
              />
            ))}
            {(selectOptions && reference.custom_reason) && (
              <ReferenceUploadPhotoFP
                globJSON={globJSON}
                simPlatform={simPlatform}
                selectOptions={selectOptions}
                subCategoryId={subCategoryId}
                TopTitle={Upload_photo_from_device}
                WithGrayBackground={!notSkipped}
                slideshowRefs={slideshowRefs}
                withAddPhoto
                showOneBigImage
              />
            )}
          </SimulatorsViewerArrangement>
        )
        : (
          <SimulatorsViewerArrangement>
            {selectOptions
              ? (
                <ReferenceMainScreenFP
                  globJSON={globJSON}
                  simPlatform={simPlatform}
                  selectOptions={selectOptions}
                  subCategoryId={subCategoryId}
                  TopTitle={Step_1_main}
                  WithGrayBackground={!notSkipped}
                  slideshowRefs={slideshowRefs}
                />
              ) : (
                <ReferenceEnterCustomReasonFP
                  globJSON={globJSON}
                  simPlatform={simPlatform}
                  subCategoryId={subCategoryId}
                  TopTitle={Step_1_main}
                  WithGrayBackground={!notSkipped}
                  inputText={reference.enter_free_text}
                  headlineText={reference.add_a_reference}
                  slideshowRefs={slideshowRefs}
                  withOutKeyboard
                />
              )}
            {selectOptions && (
            <ReferenceSelectReasonFP
              globJSON={globJSON}
              simPlatform={simPlatform}
              subCategoryId={subCategoryId}
              TopTitle={Step_2_select}
              WithGrayBackground={!notSkipped}
              slideshowRefs={slideshowRefs}
            />
            )}
            {selectOptions && reference.custom_reason && (
            <ReferenceEnterCustomReasonFP
              globJSON={globJSON}
              simPlatform={simPlatform}
              subCategoryId={subCategoryId}
              TopTitle={Step_3_enter}
              WithGrayBackground={!notSkipped}
              inputText={Thanks_for_dinner_str}
              withSubCategory
              headlineText={reference.add_a_reference}
              slideshowRefs={slideshowRefs}
              withPrimaryColor
              withOutKeyboard
            />
            )}
          </SimulatorsViewerArrangement>
        )}
    </View>
  );
};

export default ReferenceDF;
